export const ACTION = {
  ROLL_OVER: 'Roll Over',
  EDIT: 'Edit',
  DEACTIVATE: 'Deactivate',
  REACTIVATE: 'Reactivate',
  DELETE: 'Delete',
  DETAILS: 'Details',
  APPROVE: 'Approve',
  INCOMPLETE: 'Incomplete',
  INCOMPLETE_REPORT: 'Incomplete Inspection',
  RESUBMIT: 'Submit',
  NEED_RESPONSE: 'Request Variation ', // Last space is very important. Never delete this!!!
  DELETE_RESPONSE: 'Delete Variation',
  APPROVE_WITH_RESPONSE: 'Request Variation',
  APPROVE_WITHOUT_RESPONSE: 'Complete w/o Variation',
  INCOMPLETE_RESPONSE:'Incomplete Variation',
  APPROVE_RESPONSE: 'Complete Variation',
  SUBMIT_RESPONSE: 'Submit Variation',
  E_SIGN_AGREEMENT: 'E-Sign License Agreement',
  E_SIGN_REPORT: 'E-sign Inspection Report',
  BULK_APPROVE: 'Bulk Approve',
};

export const STATUS = {
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  INCOMPLETE: 'INCOMPLETE',
  COMPLETE: 'COMPLETE',
  DEACTIVATED: 'DEACTIVATED',
  DRAFT: 'DRAFT',
};

export const INSPECTION_STATUS = {
  REPORT_PENDING: 'REPORT_PENDING',
  REPORT_INCOMPLETE: 'REPORT_INCOMPLETE',
  RESPONSE_PENDING: 'RESPONSE_PENDING',
  RESPONSE_INCOMPLETE: 'RESPONSE_INCOMPLETE',
  COMPLETE: 'COMPLETE',
};



// WEBPACK FOOTER //
// ./src/app/constants/index.js